<div class="d-flex flex-column align-items-center">

  <h1 class="text-color-primary mb-3">{{ 'MULTI_DOMAIN.START.TITLE'|translate }}
  </h1>

  <h6 class="start-description text-center">{{ 'MULTI_DOMAIN.START.DESCRIPTION'|translate }}</h6>

  <h4 class="text-color-primary mb-4 mt-3 align-self-start">{{ 'MULTI_DOMAIN.START.INVITATIONS.TITLE' | translate }}</h4>
  @if (invitations().length > 0) {
    @for (invitation of invitations(); track invitation.domainId) {
      <app-multi-domain-invitation class="mb-4" [invitation]="invitation"
                                   (onAcceptInvitation)="onAcceptInvitation.emit(invitation)"
                                   (onRejectInvitation)="onRejectInvitation.emit(invitation)"/>
    }
  } @else {
    <ngx-heka-info-box class="mb-4" [type]="InfoBoxType.INFO">
      <ng-container content>
        <div class="d-flex flex-column gap-1">
          <h6>{{ 'MULTI_DOMAIN.START.INVITATIONS.EMPTY.TITLE' | translate }}</h6>
          <div>{{ 'MULTI_DOMAIN.START.INVITATIONS.EMPTY.DESCRIPTION' | translate }}</div>
        </div>
      </ng-container>
    </ngx-heka-info-box>
  }

  <span ngx-heka-clickable-dynamic-link class="text-center"
        [linkClass]="'org-create-link'"
        (linkClick)="onCreateDomain.emit()"
        [innerHTML]="'MULTI_DOMAIN.START.NEW.LINK'|translate">
</span>
</div>
